import PublicActivity from '@/pages/publicPages/PublicActivity/PublicActivity';
import PublicActivitySSP from '@/pages/publicPages/PublicActivity/PublicActivity.ssp';
import PublicActivityMetadata from '@/v2/domains/SEO/components/PublicActivityMetadata/PublicActivityMetadata';

export default function CraftActivity(props) {
  return (
    <>
      <PublicActivityMetadata {...props.pageProps} />
      <PublicActivity {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivitySSP({
    context,
    activityTypeSlug: 'crafts',
  });
